import { gql } from "@apollo/client";

const UPDATE_TARGET_ACCOUNT = gql`
  mutation updateTargetAccount(
    $id: ID!
    $accountName: String
    $contactEmail: String
    $contactWeb: String
    $contactPhone: String
    $isAutoAcceptEnabled: Boolean
    $isRequestAllEnabled: Boolean
    $isRebookingEnabled: Boolean
    $policy: PolicyInputType
    $tags: [TagsInputType]
    $notes: String
    $ownerId: ID
  ) {
    updateTargetAccount(
      id: $id
      accountName: $accountName
      contactEmail: $contactEmail
      contactWeb: $contactWeb
      contactPhone: $contactPhone
      isAutoAcceptEnabled: $isAutoAcceptEnabled
      isRequestAllEnabled: $isRequestAllEnabled
      isRebookingEnabled: $isRebookingEnabled
      policy: $policy
      tags: $tags
      notes: $notes
      ownerId: $ownerId
    ) {
      id
      accountName
      contactEmail
      contactWeb
      contactPhone
      isAutoAcceptEnabled
      isRequestAllEnabled
      isRebookingEnabled
      tags {
        id
      }
      notes
      ownerId
    }
  }
`;

export default UPDATE_TARGET_ACCOUNT;
